import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  background-color: ${({ theme }) => theme.neutral.white};
  height: 100%;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  h1 {
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
  }
  .table-separator {
    margin-left: 1.5rem;
    width: 96.5%;
    border-top: 2px solid #8f9bb3;
  }
`;

export const TableContainer = styled.div`
  margin-left: 1.5rem;
  width: 96.5%;
`;
